import store from '../store';
import { getSrchParams } from '../actions/search-actions';

const monthShort = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const dayShort = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

// export function getColors(val) {
//     switch (val) {
//         case 0:
//             return color0;
//         case 1:
//             return color1;
//         default:
//             return color0;
//     }
// }

export function findKey(obj, val, param) {
    var key = null;
    for (var prop in obj)
    {
        if (obj.hasOwnProperty(prop))
        {
            if ((param !== false && obj[prop][param] === val) || obj[prop] === val)
            {
                key = prop;
            }
        }
    }
    return key;
}

export function isInteger(num) {
    return (num % 1) === 0;
}

export function getSearchParams() {
    const myObj = {};
    const param = decodeURIComponent(window.location.search).split('?').length > 1 ? decodeURIComponent(window.location.search).split('?')[1] : false;
    const pairs = param.split('&');
    for (let i = 0; i < pairs.length; i++) {
        pairs[i] = pairs[i].split('=');
        myObj[pairs[i][0]] = pairs[i][1];
    }

    store.dispatch(getSrchParams(myObj));
    return myObj;
}

export function removeObjInArr(arr, attr, value) {
    var i = arr.length;
    while (i--) {
        if (arr[i] && arr[i].hasOwnProperty(attr) &&
            (arguments.length > 2 && arr[i][attr] === value)) {
            arr.splice(i, 1);
        }
    }
    return arr;
}

export function getDur(dep, arr) {
    const diff = (Math.abs(new Date(arr) - new Date(dep))) / (1000 * 60);
    return Math.floor(diff / 60) + 'h ' + (diff % 60) + 'm';
}

export function get24HrTime(val) {
    const dt = new Date(val);
    const hrs = dt.getHours();
    const mins = dt.getMinutes();
    return (hrs < 10 ? '0' + hrs : hrs) + ':' + (mins < 10 ? '0' + mins : mins);
}

export function getRevDate(val) {
    return val.split('-')[2] + '-' + val.split('-')[1] + '-' + val.split('-')[0];
}

export function getDateFormatted(val) {
    val = getRevDate(val);
    const dt = new Date(val);
    const day = dayShort[dt.getDay()];
    const dateVal = dt.getDate();
    const month = monthShort[dt.getMonth()];
    const year = (dt.getFullYear() + '').substr(2);
    return day + ', ' + (dateVal < 10 ? '0' + dateVal : dateVal) + ' ' + month + ' ' + year;
}

export function getDateForSrch(val) {
    const dt = new Date(val);
    const dateVal = dt.getDate();
    const month = dt.getMonth() + 1;
    const year = dt.getFullYear();
    console.log(month)
    return (dateVal < 10 ? '0' + dateVal : dateVal) + '-' + (month < 10 ? '0' + month : month) + '-' + year;
}

export function getPointTime(val) {
    val = val.split(' ');
    val[1] = val[1].split(':')[0] + ':' + val[1].split(':')[1];
    return val[1] + ' ' + val[2];
}

export function fetchGet(url) {
    return fetch(url).then(function(response){
        return response.json();
    }).then(function(data) {
        return data;
    })
}

export function fetchPost(url, postData) {
    let params = new FormData();
    Object.keys(postData).forEach(el => {
        params.append(el, postData[el]);
    });

    return fetch(url, {
        body: params,
        method: 'POST',
        mode: 'cors'
    }).then(function(response){
        return response.json();
    }).then(function(data) {
        return data;
    })
}